import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import '../../../App.css';
import { styled } from '../../../components/styled';
import SpRadio from '../../../components/atoms/SpRadio';
import SpText from '../../../components/atoms/SpText';
import SpButton from '../../../components/atoms/SpButton';
import SpTextInput from '../../../components/atoms/SpTextInput';
import SpTextArea from '../../../components/atoms/SpTextArea';
import { Add, ArrowBack, Close } from '@material-ui/icons';
import moment from 'moment';
import { Button as MuiButton, Divider, FormControlLabel, Grid, Radio } from '@material-ui/core';
import { SpSelect, SpSelectMenuItem } from '../../../components/atoms/SpSelect';
import { withSnackbar } from '../../../components/atoms/SpSnackBar';
import { theme, theme as themeStyle } from '../../../components/theme';
import { createStation, findStationById, updateStation } from '../../../models/actions/Stations';
import { nanoid } from 'nanoid';
import Geocode from 'react-geocode';
import SpIconButton from '../../../components/atoms/SpIconButton';
import SpGoogleMarker from '../../../components/bundles/googleMaps/SpGoogleMarker';
import SpGoogleMap from '../../../components/bundles/SpGoogleMap';
import { UserSessionContext } from '../../../App';
import { findAllUsers } from '../../../models/actions/Users';

//Setting up geocode
Geocode.setApiKey('AIzaSyC0KvC-l9aD8fS42m3aVZytFL893tMCw4A');
Geocode.setLanguage('it');
Geocode.setRegion('it');

const CustomRadioButton = styled(Radio)({
  color: themeStyle.colors.mainGreen.secondary,
  border: `1px solid ${themeStyle.colors.mainGreen.secondary}`
});

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const AdminStationDetail = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [selectedAdminUser, setSelectedAdminUser] = useState(null);
  const [bikeSharingActive, setBikeSharingActive] = useState(0);
  const [inputError, setInputError] = useState(false);
  const [error, setError] = useState(null);
  const [stationAdminUsers, setStationAdminUsers] = useState([]);
  const [selectedPosition, setSelectedPosition] = useState(null);
  const { authData, setAuthData } = useContext(UserSessionContext);

  const { stationId } = useParams();
  const history = useHistory();

  const { register, getValues, handleSubmit, reset } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const fetchData = async () => {
    if (stationId) {
      try {
        let response = await findStationById({ id_station: stationId }, authData.accessToken);
        if (response) {
          reset({ ...response });
          setSelectedPosition({ lat: response.lat, lng: response.lng });
          setBikeSharingActive(response.sharingAvailable === 'false' ?  1 : 2);
          setSelectedAdminUser(response.id_user);
        }
      } catch (error) {
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  const fetchUsersData = async () => {
    try {
      const response = await findAllUsers(null, authData.accessToken);
      if (response) {
        const newArray = response.filter((s) => s.type != 'ADMIN' && s.device_os !== 'android' && s.device_os !== 'ios');
        setStationAdminUsers(newArray);
        const formValues = getValues();
        console.log(newArray.find((e) => e.id === formValues.id_user));
        //setSelectedAdminUser(newArray.find((e) => e.id === formValues.id_user) ?? 0);
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUsersData();
  }, []);

  const saveStation = async (data) => {
    try {
      props.isLoading(true);
      if (stationId) {
        if (selectedPosition) {
          const response = await updateStation({ station: { ...getValues(), id: stationId,sharingAvailable: bikeSharingActive === 2 ? 'true' : 'false', id_user: selectedAdminUser, lat: selectedPosition.lat, lng: selectedPosition.lng } }, authData.accessToken);
          if (response) {
            setCurrentStation(response);
            props.snackbarShowMessage(response.message);
          }
          setInputError(false);
        } else {
          setInputError(true);
        }
        props.isLoading(false);
      } else {
        if (selectedPosition) {
          const response = await createStation({ station: { ...getValues(), id_user: selectedAdminUser, sharingAvailable: bikeSharingActive === 2 ? 'true' : 'false', lat: selectedPosition.lat, lng: selectedPosition.lng } }, authData.accessToken);
          props.isLoading(false);
          response && history.push('/admin/stations');

          setInputError(false);
        } else {
          setInputError(true);
        }
        props.isLoading(false);
      }
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  const handlePositionChose = (dataFromMap) => {
    reset({ ...getValues(), lat: dataFromMap.lat, lng: dataFromMap.lng });
    setSelectedPosition({ lat: dataFromMap.lat, lng: dataFromMap.lng });
  };

  const formControlStyleInput = { width: '100%', marginTop: '1%' };

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        {stationId && (
          <Grid
            item
            container
            xs={12}
            spacing={1}
            justifyContent="flex-end"
          >
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Ebike'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push({ pathname: `/admin/stations/edit/${stationId}/ebikes`, state: { stationData: getValues() && stationId ? getValues() : currentStation } })}
              />
            </Grid>
            {/* <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Noleggi'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/admin/stations/edit/${stationId}/rents`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Prenotazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/admin/stations/edit/${stationId}/reservations`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Segnalazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/admin/stations/edit/${stationId}/reports`)}
              />
            </Grid> */}
          </Grid>
        )}
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push('/admin/stations')}
                style={{ width: 25, color: themeStyle.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {stationId ? `Home / Stazione / ` : `Home / Stazione `}
              </SpText>
              <SpText variant="breadcrumbsSelected">{getValues('name') && stationId ? getValues('name') : currentStation?.name}</SpText>
            </TitleToolbarSection>
          </Grid>

          {/* {stationId ? (
            <Grid item xs={3}>
            <SpButton buttonType='accept' text={"Modifica"} style={{ width: "100%" }} variant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					) : (
            <Grid item xs={3}>
            <SpButton buttonType='accept' text={"Salva"} style={{ width: "100%" }} ariant='h1PageTitle' onClick={handleSubmit(saveStation)} />
						</Grid>
					)} */}
        </Grid>

        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
          style={{ backgroundColor: 'rgb(77, 172, 39,0.7)' }}
        >
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            {stationId ? (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Modifica'}
                  style={{ width: '100%' }}
                  variant="h1PageTitle"
                  onClick={handleSubmit(saveStation)}
                />
              </Grid>
            ) : (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Salva'}
                  style={{ width: '100%' }}
                  ariant="h1PageTitle"
                  onClick={handleSubmit(saveStation)}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            item
            xs={12}
          >
            <Grid
              item
              xs={12}
            >
              {error && <SpText variant="h4ComponentLabelError">{error}</SpText>}
              {inputError && <SpText variant="inputError">Devi riempire i campi obbligatori</SpText>}
            </Grid>
            <form>
              <SpTextInput
                label="Nome (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="name"
              />
              <SpTextInput
                label="Mac address (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="mac_address"
              />
              <SpTextInput
                label="Client id (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="client_id"
              />
              <SpTextInput
                label="Numero di telefono assistenza (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="support_phone"
              />
              <SpSelect
                value={bikeSharingActive}
                defaultValue={bikeSharingActive}
                label="Bike sharing attivo"
                labelColor={'black'}
                onChange={(e) => {
                  console.log(e.target.value);
                  setBikeSharingActive(e.target.value);
                }}
              >
                {[{id: 2, name: 'Si'},{id: 1, name: 'No'}].map((value) => {
                  console.log(value);
                  return (
                    <SpSelectMenuItem
                      key={value.id}
                      value={value.id}
                    >
                      {value.name}
                    </SpSelectMenuItem>
                  );
                })}
              </SpSelect>
              <SpTextInput
                label="Numero di telefono per allarme sicurezza (obbligatorio)"
                labelColor={'black'}
                type="string"
                formControlStyle={formControlStyleInput}
                variant="inputLabel"
                inputRef={register}
                name="alarm_phone"
              />
              <SpSelect
                value={selectedAdminUser}
                defaultValue={selectedAdminUser}
                label="Scegli l'utente proprietario"
                labelColor={'black'}
                onChange={(e) => {
                  setSelectedAdminUser(e.target.value);
                }}
              >
                {stationAdminUsers.map((value) => {
                  console.log(value);
                  return (
                    <SpSelectMenuItem
                      key={value.id}
                      value={value.id}
                    >
                      {value.name}
                    </SpSelectMenuItem>
                  );
                })}
              </SpSelect>
              {/* <SpTextInput label='Regione (obbligatorio)' labelColor={"black"} type='string' formControlStyle={formControlStyleInput} variant='inputLabel' inputRef={register} name='region' />
							<SpTextInput label='Provincia ' labelColor={"black"} type='string' formControlStyle={formControlStyleInput} variant='inputLabel' inputRef={register} name={"province"} />
							<SpTextInput label='Città' labelColor={"black"} type='string' formControlStyle={formControlStyleInput} variant='inputLabel' inputRef={register} name='city' />
							<SpTextInput label='Via' labelColor={"black"} type='string' formControlStyle={formControlStyleInput} variant='inputLabel' inputRef={register} name='street' /> */}
              <SpText
                variant="inputLabel"
                style={{ color: 'black', alignSelf: 'center' }}
              >
                Scegli la posizione della stazione da aggiungere
              </SpText>
              <SpGoogleMap
                markers={selectedPosition ? [selectedPosition] : []}
                CustomMarker={SpGoogleMarker}
                onClick={handlePositionChose}
              />
            </form>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default withSnackbar(AdminStationDetail);
